import React, { Component } from "react";
import { Components } from "@webtech/webtech-ui-react/build/webtech-ui";

export interface SwitchProps {
    field?: any;
    form?: any;
    givenid: string;
    onChange?: (e) => void;
    disabled?: boolean;
}

export default class BaseSwitch extends Component<SwitchProps, {}> {
    handleOnChange = () => {
        this.props.form.setFieldValue(
            this.props.field.name,
            !this.props.field.value
        );
    };

    render() {
        return (
            <div id={this.props.givenid + "Switch"}>
                <div className="input-group">
                    <Components.Switch
                        enabled={!this.props.disabled}
                        on={this.props.field.value}
                        onClick={this.handleOnChange}
                    />
                </div>
            </div>
        );
    }
}
